import ParecerReferencialService from '@/views/parecer-referencial/service/ParecerReferencialService';
import SdsSnackbarQueue from '@ungp/sds-snackbar-queue';
import { defineStore } from 'pinia';
import { FiltroParecerReferencial, ParecerReferencialList } from '../types';
import { PaginatedRest } from '@/types/common/Rest';
import { SimNao } from '@/types/enum/SimNao';
import { getAxiosError } from '@/plugins/axios';

export const getInitialResult =
  (): PaginatedRest<ParecerReferencialList | null> => ({
    content: null,
    number: 0,
    size: 10,
  });

export const getInitialFilter = (): FiltroParecerReferencial => ({
  dtParecerDe: '',
  dtParecerAte: '',
  dtValidadeDe: '',
  dtValidadeAte: '',
  nuAnoProcesso: '',
  nuProcesso: '',
  nuAnoParecer: '',
  nuParecer: '',
  flMostraInternet: SimNao.FL_SIM,
  flVencidos: SimNao.FL_NAO,
  flForaUso: SimNao.FL_NAO,
});

type State = {
  result: PaginatedRest<ParecerReferencialList | null>;
  filter: FiltroParecerReferencial;
};

export const useConsultaParecerReferencialStore = defineStore(
  'ConsultaParecerReferencialStore',
  {
    state: (): State => ({
      result: getInitialResult(),
      filter: getInitialFilter(),
    }),
    actions: {
      async listar(resetPagination = false) {
        if (resetPagination) {
          this.result.number = getInitialResult().number;
        }

        try {
          const { data } = await ParecerReferencialService.listar(
            this.filter,
            this.result.number,
            this.result.size
          );

          this.result = data;
        } catch (error) {
          SdsSnackbarQueue.error(
            getAxiosError(error, 'Não foi possível buscar os registros')
          );
        }
      },
    },
  }
);
